/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
import CustomDateTime from './CustomDateTime';
import CustomDropdown from './CustomDropdown';
import CustomRadioButton from './CustomRadioButton';
import CustomTextField from './CustomTextField';
import CustomTextarea from './CustomTextarea';
import CustomToggle from './CustomToggle';
import CustomToggleV2 from './CustomToggleV2';
import CustomCheckbox from './CustomCheckbox';
import CustomMultipleCheckboxes from './CustomMultipleCheckboxes';
import CustomMultipleRoundedCheckboxes from './CustomMultipleRoundedCheckboxes';
import CustomLabel from './CustomLabel';
import CustomAutocompleteDMTI from './CustomAutocompleteDMTI';
import CustomAutocomplete from './CustomAutocomplete';
import CustomPinDrop from './CustomPinDrop';
import CustomUploadFile from './CustomUploadFile';
import CustomTabs from './CustomTabs';
import CustomAudaTarget from './CustomAudaTarget';
import CustomAddPassenger from './CustomAddPassenger';
import CustomReviewSection from './CustomReviewSection/CustomReviewSection';
import CustomReviewSectionArray from './CustomReviewSection/CustomReviewSectionArray';
import CustomPeopleInTheOtherVehicles from './CustomPeopleInTheOtherVehicles';
import CustomWhatAreTheInjuries from './CustomWhatAreTheInjuries';
import CustomInteriorRooms from './CustomInteriorRooms';
import CustomScheduledItems from './CustomScheduledItems';
import CustomAddDepartment from './CustomAddDepartment';

export default {
  customradiobutton: CustomRadioButton,
  customdatetime: CustomDateTime,
  customtoggle: CustomToggle,
  customtogglev2: CustomToggleV2,
  customtextfield: CustomTextField,
  customtextarea: CustomTextarea,
  customdropdown: CustomDropdown,
  customcheckbox: CustomCheckbox,
  custommultiplecheckboxes: CustomMultipleCheckboxes,
  custommultipleroundedcheckboxes: CustomMultipleRoundedCheckboxes,
  customlabel: CustomLabel,
  customautocompletedmti: CustomAutocompleteDMTI,
  customautocomplete: CustomAutocomplete,
  custompindrop: CustomPinDrop,
  customuploadfile: CustomUploadFile,
  customtabs: CustomTabs,
  customaudatarget: CustomAudaTarget,
  customaddpassenger: CustomAddPassenger,
  customreviewsection: CustomReviewSection,
  customreviewsectionarray: CustomReviewSectionArray,
  customPeopleInTheOtherVehicles: CustomPeopleInTheOtherVehicles,
  customWhatAreTheInjuries: CustomWhatAreTheInjuries,
  customInteriorRooms: CustomInteriorRooms,
  customScheduledItems: CustomScheduledItems,
  customAddDepartment: CustomAddDepartment,
};
